import { FeatureGroup } from "./../feature-selector/model/feature-group";

export enum ThemeEnums {
  FACILIS = "facilis-theme",
  BHANSA = "bhansa-theme",
}

export interface AnnotationLanguages {
  key: string;
  label: string;
}

export interface AppConfig {
  apiServer: {
    url: string;
    fqaUrl: string;
  };
  validatorApiServer: {
    url: string;
    validatorUrl: string;
  };
  keycloakServer: {
    url: string;
    realm: string;
    clientId: string;
    credentialsSecret: string;
  };
  catalogsApiServer: {
    url: string;
  }
  role: {
    role_FO_Module: string;
    role_Ais_Admin: string;
    role_Ais_Reviewer: string;
    role_Saf_Reviewer: string;
    role_Nof_Reviewer: string;
    role_Data_Manager: string;
    role_Data_Provider: string;
    role_Data_Reader: string;
    role_LS_Module: string;
    role_Fqa_Module: string;
    role_Fqa_Quality_Contoller: string;
    role_Fqa_Project_Manager: string;
    role_Fqa_Editor: string;
    role_Validator_Module: string;
  };
  visTimeLineOptions: {
    min: string;
    max: string;
  };
  baseHelpUrl: {
    faivaDocUrl: string;
    xwikiUrl: string;
  };
  geoServer: {
    url: string;
    unWorkspaceName: string;
    officialWorkspaceName: string;
    layerName: string;
    officialLayerName: string;
  };
  app: {
    url: string;
    title: string;
  };
  periodToCalculateValidEffDate;
  amdtNoticePeriod: number;
  supNoticePeriod: number | null;
  featureTypesForPointRef: FeatureGroup[];
  isDataProvider: boolean;
  isUnReader: boolean;
  isAis: boolean;
  enablePiwikPro: boolean;
  enableValidation: boolean;
  annotationLanguages: AnnotationLanguages[];
  theme: ThemeEnums;
}
